'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fal';
var iconName = 'money-bill-trend-up';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'e529';
var svgPathData = 'M480 16c0-4.2-1.7-8.3-4.7-11.3S468.2 0 464 0L362.2 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l63.2 0-138.2 138.2-100.8-86.4c-6-5.1-14.8-5.1-20.8 0l-112 96c-6.7 5.8-7.5 15.9-1.7 22.6s15.9 7.5 22.6 1.7L176 117.1 277.6 204.1c6.3 5.4 15.8 5.1 21.7-.8L448 54.6 448 117.8c0 8.8 7.2 16 16 16s16-7.2 16-16L480 16zM464 288c8.8 0 16 7.2 16 16l0 32c-26.5 0-48-21.5-48-48l32 0zm-352 0l288 0c0 44.2 35.8 80 80 80l0 32c-44.2 0-80 35.8-80 80l-288 0c0-44.2-35.8-80-80-80l0-32c44.2 0 80-35.8 80-80zM432 480c0-26.5 21.5-48 48-48l0 32c0 8.8-7.2 16-16 16l-32 0zM32 432c26.5 0 48 21.5 48 48l-32 0c-8.8 0-16-7.2-16-16l0-32zM80 288c0 26.5-21.5 48-48 48l0-32c0-8.8 7.2-16 16-16l32 0zM48 256c-26.5 0-48 21.5-48 48L0 464c0 26.5 21.5 48 48 48l416 0c26.5 0 48-21.5 48-48l0-160c0-26.5-21.5-48-48-48L48 256zM224 384a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faMoneyBillTrendUp = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;